export const searchComponentInstances = new Set();
